<h2 mat-dialog-title>
  <span class="groupIcon">
    <mat-icon>email</mat-icon>
  </span>
  <p>Follow Up Referral & Send Email</p>
  <button mat-icon-button (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content class="mat-typography">

  <!-- Confirmation Message -->
  <div class="confirm-box">
    <mat-icon>email</mat-icon>
    <p>
      Do you want to <strong>Follow Up this referral</strong> and
      <strong>send email notification</strong> to the selected emails?
    </p>
  </div>
 
   <div style="font-size: 16px;"> 
    This is to inform you that a <strong>follow-up</strong> has been initiated for <strong>{{ personName }}</strong>
   </div>

  <div class="block mt-10">
    <div class="relative">

      <mat-form-field appearance="outline">
        <mat-label>Message</mat-label>
        <textarea matInput placeholder="Add message"
          rows="4" 
          cdkAutosizeMinRows="4"
          cdkAutosizeMaxRows="8"
          [(ngModel)]="message">
        </textarea>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput maxlength="200"
          placeholder="Add email" [(value)]="emailAssigned"
          (input)="emailCheck($event.target.value)"/>
      </mat-form-field>

      <button color="primary" *ngIf="addEmailButtonShow"
        (click)="addEmail()" mat-icon-button class="addBtn">
        <mat-icon>add</mat-icon>
      </button>
    </div>
  </div>

  <!-- Selected Email List -->
  <ul class="selectedlist">
    <li *ngFor="let ass of addUpdateParticipantList">
      <div class="userndetail">
        <div class="userpic">
          <img *ngIf="ass.img != ''" [src]="ass.img" alt="">
          <span *ngIf="ass.img == ''" class="username">
            {{ ass.shortName }}
          </span>
        </div>

        <div class="details">
          <h4>{{ ass.name }}</h4>
          <p>{{ ass.email }}</p>
        </div>

        <div class="opt">
          <button mat-icon-button matTooltip="Remove">
            <mat-icon (click)="removeParticipant(ass)">cancel</mat-icon>
          </button>
        </div>
      </div>
    </li>
  </ul>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cancel</button>

  <button mat-flat-button color="primary"  [disabled]="addUpdateParticipantList.length==0 && !message"
    type="submit" (click)="FollowUpAndSendMail()"
     class="calltoaction">FollowUp & Send Mail     
  </button>
</mat-dialog-actions>

<app-loader></app-loader>
